export const MANUAL = 'manual';
